import React from "react"
import ListEntry from "../../../../../components/Order/Ui/ListEntry"
import { useQuery } from "@apollo/client"
import GET_TAX_GROUP from "../../../../../graphql/queries/tax/GetTaxGroup"

type PaymentTax = {
  id: string
  taxPercentage: number
  taxPercentageDecimals: number
}

type Props = {
  paymentTax: PaymentTax
}

const TaxGroup = ({ paymentTax }: Props) => {
  const { data } = useQuery(GET_TAX_GROUP, { variables: { id: paymentTax.id } })

  if (!data) return null
  return (
    <ListEntry
      label={"Tax group"}
      value={`${data?.getTaxGroup?.name} - ${paymentTax.taxPercentage / 10 ** paymentTax.taxPercentageDecimals + "%"}`}
    />
  )
}

export default TaxGroup
